'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (series, store, layout, isStacked, colors) {
    return [{
        name: series[0].name,
        colorByPoint: true,
        allowPointSelect: true,
        cursor: 'pointer',
        data: (0, _getCategories2.default)(store, layout).map(function (category, index) {
            return {
                name: category,
                color: colors[index],
                y: series[0].data[index]
            };
        }),
        dataLabels: {
            enabled: true,
            formatter: function formatter() {
                return '<span style="font-weight:normal">' + this.point.name + '</span><br/>' + this.y + '<span style="font-weight:normal"> (' + this.percentage.toFixed(1) + ' %)</span>';
            }
        }
    }];
};

var _getCategories = require('../getCategories');

var _getCategories2 = _interopRequireDefault(_getCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=pie.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/series/pie.js
 ** module id = 247
 ** module chunks = 0 1
 **/